/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from '../../../message';
import { IDescriptorBody } from '../../../descriptor';

export interface IResolveCommentThreadMessage extends IMessage {
	commentThreadId: string;
	documentId: string;
	resolvedBy?: string;
	resolvedAt?: string;
}

export default class ResolveCommentThreadMessage extends Message {
	public readonly resolvedAt?: Date;

	public static readonly TYPE: string = '142';

	public static readonly READABLE_TYPE_NAME: string = 'resolveCommentThread';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2ResolveCommentThreadMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			},
			resolvedBy: {
				type: 'string',
				id: 3
			},
			resolvedAt: {
				type: 'string',
				id: 4
			}
		}
	};

	public constructor(
		public readonly commentThreadId: string,
		public readonly documentId: string,
		public readonly resolvedBy?: string,
		resolvedAt?: string
	) {
		super();

		this.resolvedAt = resolvedAt ? new Date( resolvedAt ) : undefined;
	}

	public toJSON(): IResolveCommentThreadMessage {
		return {
			documentId: this.documentId,
			commentThreadId: this.commentThreadId,
			resolvedBy: this.resolvedBy,
			resolvedAt: this.resolvedAt?.toISOString()
		};
	}

	public static fromJSON( object: IResolveCommentThreadMessage ): ResolveCommentThreadMessage {
		return new ResolveCommentThreadMessage(
			object.commentThreadId,
			object.documentId,
			object.resolvedBy,
			object.resolvedAt
		);
	}
}
